import { takeLatest, call, put } from 'redux-saga/effects';

import { getStaticData, searchProducts } from './api';
import {
  fetchStaticDataSuccess,
  fetchStaticDataFail,
  fetchSearchProductsSuccess,
  fetchSearchProductsFail,
} from './actions';
import commonActionTypes from './action-types';

function* fetchStaticDataSaga({ payload }) {
  try {
    const response = yield call(getStaticData, payload);
    yield put(fetchStaticDataSuccess(response.data));
  } catch (error) {
    yield put(fetchStaticDataFail(error));
  }
}

function* fetchSearchProductsSaga({ payload }) {
  try {
    const response = yield call(searchProducts, payload);
    yield put(fetchSearchProductsSuccess(response.data));
  } catch (error) {
    yield put(fetchSearchProductsFail(error));
  }
}

function* commonSaga() {
  yield takeLatest(commonActionTypes.FETCH_STATIC_DATA, fetchStaticDataSaga);
  yield takeLatest(commonActionTypes.FETCH_SEARCH_PRODUCTS, fetchSearchProductsSaga);
}

export default commonSaga;
